import { INSERT_TEAM_AND_USER } from "../graphql/CreateNewTeamAndUser";
import { UPDATE_USER } from "../graphql/UpdateUser";
import { apolloClient } from "@/main";
import { apolloClientFactory, headersBuilder } from "@/utilities/ApolloClient";
import { User } from "@/modules/user/class-definitions/user";

/**
 * @param {User} user
 */
export const updateUserPromise = user => {
  return new Promise((resolve, reject) => {
    apolloClient
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          id: user.id,
          name: user.name,
          email: user.email
        }
      })
      .then(updatedRecord => {
        resolve(updatedRecord);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/**
 * - Takes a user relationship from a Hasura record and returns an instantiated User.
 * @param {object} user
 * @returns {User}
 */
export const filterUserRelationship = user => {
  return user
    ? new User({
        id: user.id,
        name: user.name,
        email: user.email,
        hospitalId: user.hospital_id
      })
    : {};
};

/**
 * @param {User} user
 */
export const createNewTeamAndUserPromise = user => {
  return new Promise((resolve, reject) => {
    let scopedApolloHeaders = headersBuilder(user.idToken);
    let scopedApolloClient = apolloClientFactory(scopedApolloHeaders);
    scopedApolloClient
      .mutate({
        mutation: INSERT_TEAM_AND_USER,
        variables: {
          authId: user.authId,
          name: user.name,
          email: user.email
        }
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// /**
//  * @param {User} user
//  */
// export const createNewUserSettings = user => {
//   /**
//    * @param {Setting} setting
//    */
//   settingList.forEach(setting => {
//     let newSetting = new Setting({
//       title: setting.title,
//       colour: setting.colour,
//       teamId: user.team.id
//     });
//     newSetting
//       .saveSetting()
//       .then(response => {
//         console.log("setting created: ", response);
//       })
//       .catch(error => {
//         console.error(error);
//       });
//   });
// };
